import styled from 'styled-components';

export const StyledSidebarMenuItem = styled('div')`
  .ant-badge-count {
    background: ${({ theme }) => theme.badgeBackground};
    font-size: 15px;
    box-shadow: none;
  }
`;
